import React, { Fragment } from "react"
import { Form, Button, Input, Select, message, InputNumber, notification, Icon } from "antd"
import gql from "../../api/gql"
import TextArea from "antd/lib/input/TextArea";
import * as _ from "lodash"

const CURRENCY = 'USD';

class NewDepositForm extends React.Component {
  state = {
    loading: false,
    sites: [],
    site_id: null,
    siteFilter: {
      user_id: null,
      verified: true
    },
    depositAmount: 1,
    balanceAmount: 1,
    initSetting: [],
    paypalButtonRendered: false
  };

  paypalButtonRef = React.createRef();

  componentDidMount() {
    this.loadSites()
    this.loadAppSetting()
    this.loadPaypalScript()
  }

  loadPaypalScript() {
    // Xóa script cũ nếu có
    const existingScript = document.getElementById('paypal-sdk');
    if (existingScript) {
      existingScript.remove();
    }

    // Tạo và thêm script PayPal vào DOM
    const script = document.createElement('script');
    script.id = 'paypal-sdk';
    script.src = `https://www.paypal.com/sdk/js?client-id=AVFqL9mWA3idXcb1rfkleFEBiCHpBTBAQqybCLWAilUQZWCop71VvTBV52BERSH8jIQWOZNp18K__EsW&currency=USD&debug=false&components=buttons`;
    script.async = true;
    script.onload = () => {
      this.renderPayPalButton();
    };
    document.body.appendChild(script);
  }

  loadAppSetting() {
    const query = `query getAppSettings($input: [String!]){
      getAppSettings(input: $input){
        name
        value
      }
    }`
    const input = ["payment_mode", "payment_sandbox_key", "payment_production_key"]
    this.setState({ loading: true })
    gql.request(query, { input: input })
        .then(res => {
          this.setState({ initSetting: res.getAppSettings || [], loading: false })
        })
        .catch(err => {
          notification.error({
            message: 'Error',
            description: _.get(err, "[0].message")
          })
          this.setState({ loading: false })
        })
  }

  onClose = () => {
    this.props.onClose();
  };

  onhandleSelect = (value) => {
    this.setState({
      site_id: value
    })
  }

  loadSites() {
    const { currentUser } = this.props;
    if (!currentUser) return null;
    const admin = currentUser.roles.find(role => role.name === "Administrator")
    const query = `query sites($filter: SiteFilter) {
      sites(filter: $filter){
        hits {
          id
          title
        }
      } 
    }`
    this.setState({
      loading: true
    })
    gql.request(query, {
      filter: {
        ...this.state.siteFilter,
        user_id: (admin ? null : +this.props.currentUser.id)
      }
    }).then(res => {
      this.setState({
        sites: res.sites.hits || [],
        loading: false,
        site_id: res.sites.hits && res.sites.hits.length > 0 ? res.sites.hits[0].id : 0
      })
    }).catch(err => {
      notification.error({
        message: 'Error',
        description: _.get(err, "[0].message", "An error occurred while loading sites")
      });
      this.setState({ loading: false });
    });
  }

  onPaypalDepositSuccess = (details) => {
    const siteId = this.state.site_id
    const inputAmount = parseFloat(this.state.depositAmount)
    const amount = inputAmount; // Không áp dụng phí PayPal

    if (siteId && details) {
      let transactionId;

      try {
        if (details.id) {
          transactionId = details.id;
        } else if (details.purchase_units && details.purchase_units[0]) {
          const payments = details.purchase_units[0].payments;
          if (payments && payments.captures && payments.captures[0]) {
            transactionId = payments.captures[0].id;
          }
        }
      } catch (error) {
        console.error("Error extracting transaction ID:", error);
      }

      if (!transactionId) {
        transactionId = "paypal-" + new Date().getTime();
      }

      const mutation = `mutation createBalance($input: NewBalance!){
          createBalance(input: $input){
            id
            action
            actionNotes
            amount
            transaction_id
            site{
              id
              title
              domain
              platform
            }
          }
        }`
      this.setState({ loading: true })
      gql.request(mutation, {
        input: {
          transaction_id: transactionId,
          site_id: siteId,
          amount: amount,
          action_notes: "Paypal Express pay",
          approved: true
        }
      }).then(res => {
        this.setState({
          loading: false
        })
        this.props.onLoad()
        message.success("PayPal payment successful! Deposit has been created.");
      }).catch(err => {
        notification.error({
          message: 'Error',
          description: _.get(err, "[0].message", "An error occurred with PayPal deposit")
        });
        this.setState({ loading: false });
      });
    } else {
      message.error("Create Deposit failed. Please contact Administrator for details!");
    }
  }

  handleAmountChange = (value) => {
    if (value && !isNaN(value) && parseFloat(value) > 0) {
      this.setState({
        depositAmount: parseFloat(value),
        balanceAmount: parseFloat(value).toFixed(2)
      });
    } else {
      this.setState({
        depositAmount: 1,
        balanceAmount: "1.00"
      });
    }
  }

  renderPayPalButton = () => {
    if (!window.paypal) {
      console.log("PayPal SDK not loaded");
      return;
    }

    const container = this.paypalButtonRef.current;
    if (!container) {
      console.error("PayPal button container not found");
      return;
    }

    while (container.firstChild) {
      container.removeChild(container.firstChild);
    }

    try {
      window.paypal.Buttons({
        style: {
          layout: 'vertical',
          color: 'blue',
          shape: 'rect',
          label: 'paypal'
        },
        createOrder: (data, actions) => {
          const amount = this.state.depositAmount;
          if (!amount || isNaN(amount) || amount <= 0) {
            message.error("Please enter a valid amount greater than 0");
            return Promise.reject(new Error("Invalid amount"));
          }

          return actions.order.create({
            purchase_units: [{
              amount: {
                currency_code: CURRENCY,
                value: amount.toString()
              }
            }]
          });
        },
        onApprove: (data, actions) => {
          this.setState({ loading: true });

          return actions.order.capture()
              .then((details) => {
                console.log("PayPal payment completed:", details);
                this.onPaypalDepositSuccess(details);
              })
              .catch(err => {
                console.error("PayPal capture error:", err);
                notification.error({
                  message: 'Payment Error',
                  description: 'There was an error processing your payment.'
                });
                this.setState({ loading: false });
              });
        },
        onError: (err) => {
          console.error('PayPal Error:', err);
          notification.error({
            message: 'PayPal Error',
            description: 'There was an error setting up the payment. Please try again.'
          });
          this.setState({ loading: false });
        }
      }).render(container);

      this.setState({ paypalButtonRendered: true });
    } catch (error) {
      console.error("Error rendering PayPal buttons:", error);
      notification.error({
        message: 'PayPal Integration Error',
        description: 'Could not load PayPal checkout. Please try again later.'
      });
    }
  }

  render() {
    const { sites, loading } = this.state;

    return (
        <Fragment>
          {/*<h3 style={{ marginTop: 20 }}>*/}
          {/*  Please send payment to{" "}*/}
          {/*  <span style={{ color: "red", fontWeight: "bold" }}>*/}
          {/*              it.abninnovation@gmail.com*/}
          {/*          </span>{" "}*/}
          {/*  via PayPal.*/}
          {/*</h3>*/}
          <div><img style={{width:"100%"}} src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjukLtBEicFuIOuKKJ4o1Gt_L6S6VX5jxh1SJeWUO01JMpoPkj_7jf88kngSYMTImbtVrc3Oiy04GB1UakhxmTbqs2fGj4E8yLabO3vIqteAWqqK2kgGBiire71mVXeu-OMpsQ-7Ok4oDM/s1600/banner_paypal.jpg"/></div>

          <div>
            <Form.Item label="Site" style={{ marginTop: 20 }}>
              <Select
                  onChange={this.onhandleSelect}
                  style={{ width: '100%' }}
                  defaultValue={sites && sites.length > 0 ? sites[0].id : undefined}
                  disabled={loading}
              >
                {sites.map((site) => (
                    <Select.Option key={site.id} value={site.id}>{site.title}</Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item label="Paypal Amount">
              <InputNumber
                  value={this.state.depositAmount}
                  style={{ width: '100%' }}
                  formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={value => value.replace(/\$\s?|(,*)/g, '')}
                  onChange={this.handleAmountChange}
                  step={0.1}
                  min={1}
                  disabled={loading}
              />
            </Form.Item>

            <Form.Item label="Balance Amount" style={{ display: "none" }}>
              <InputNumber
                  readOnly
                  value={this.state.balanceAmount}
                  style={{ width: '100%' }}
                  formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={value => value.replace(/\$\s?|(,*)/g, '')}
                  disabled
              />
            </Form.Item>

            <div>
              Please select site and input amount before clicking on the PayPal button.
              <span style={{ color: 'red', fontWeight: 'bold' }}> The minimum deposit amount is $1.</span>
            </div>

            <div ref={this.paypalButtonRef} style={{ marginTop: 20 }}></div>

            <div style={{ display: "flex", marginTop: 10 }}>
              <Icon type="info-circle" style={{ lineHeight: "22px", marginRight: 8 }} />
              <span>After payment is successful, system will create deposit automatically</span>
            </div>

            <Form.Item style={{ marginTop: 20 }}>
              <Button style={{ width: "100%" ,background:"#e83f3f",height:40,color:"white",fontWeight:500}} onClick={() => { this.onClose() }} loading={loading}>
                Cancel
              </Button>
            </Form.Item>
          </div>
        </Fragment>
    );
  }
}

export default Form.create({ name: "create-a-deposit" })(NewDepositForm);